import { render, staticRenderFns } from "./Telephone.vue?vue&type=template&id=2d996aba&scoped=true&"
import script from "./Telephone.vue?vue&type=script&lang=ts&"
export * from "./Telephone.vue?vue&type=script&lang=ts&"
import style0 from "./Telephone.vue?vue&type=style&index=0&id=2d996aba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d996aba",
  null
  
)

export default component.exports